const $ = require("jquery");
const { Foundation, dataLayer } = window;
const FormController = require("../../utilities/_form-controller");
const _ = require("lodash");
const Stepper = require("../stepper/Stepper");
const kickboxCheck = require("../../src/run/kickbox/kickboxCheck");
const CtaAfterSubmission = require("../../utilities/CtaAfterSubmission");
const Form_init = require("../../src/Form_init");

class SecondaryDemoFormStepper {
	constructor (id) {
		this.id = id;
		this.setupForm();
		this.stepper = new Stepper(this.getStepperId());
		this.SUBMITTED_DURING_THIS_SESSION = "SUBMITTED_DURING_THIS_SESSION";
	}

	setupForm () {
		new Foundation.Abide(this.getForm());

        const $form = this.getForm();

		$form
			.on("formvalid.zf.abide", () => this.submit())
			.on("submit", e => e.preventDefault());

		Form_init($form[0]);

		this.initializeConfirmationVideo();
	}

	getRoot () {
		return $(`#${this.id}`);
	}

	getRootElement() {
		return this.getRoot()[0];
	}

	getStepper () {
		return this.getRoot().find("[data-component=stepper]");
	}

	getStepperId () {
		return this.getStepper().attr("id");
	}

	getForm () {
		return this.getRoot().find("form");
	}

	getFormId () {
		return this.getForm().attr("id");
	}

	getReveal () {
		return this.getRoot().find(".reveal");
	}

	getSubmitButton () {
		return this.getForm().find("button[type=submit]");
	}

	getCountryField () {
		return this.getForm().find('[name="Country"]');
	}

	getPrivacyPolicyAgreementMessageContainer() {
		return this.getForm().find('[data-component="privacy-policy-agreement-message-container"]');
	}

	getPrivacyPolicyCheckboxContainer() {
		return this.getForm().find('[data-component="privacy-policy-checkbox-container"]');
	}

	disableSubmitButton () {
		this.getSubmitButton().attr("disabled", "true");
	}

	serializeFormData () {
		return _.reduce(
			this.getForm().serializeArray(),
			(data, field) => _.set(data, field.name, field.value),
			{}
		);
	}

	async submit () {
		this.disableSubmitButton();

		this.stepper.nextStep();

		const data = this.serializeFormData();

		const email = _.get(data, 'Email');

		const kickboxResponse = await kickboxCheck(email);
		const Email_Verification_Status__c = kickboxResponse.result;
		const kickboxReason = kickboxResponse.reason;

		_.set(
			data,
			'Email_Verification_Status__c',
			Email_Verification_Status__c
		);

		_.set(
			data,
			'kickboxReason',
			kickboxReason
		);

		try {
			if (!["iterable.test", "localhost"].includes(window.location.hostname)) {
				await FormController.marketo__submit(
					data,
					false,
					null,
					this.getForm()
				);
			}

			this.whenSubmitted();

			dataLayer.push({ event: 'ajaxFormSubmitted' });
		} catch (e) {
			console.error(e);
		} finally {
			this.stepper.nextStep();
			this.showConfirmationStep();
		}
	}

	showConfirmationStep() {
		this.getRoot()[0].querySelector('[data-component="confirmation-step"]').style.display = '';
	}

	initializeConfirmationVideo() {
		const videoContainer = this.getRoot()[0].querySelector('[data-component="video-container"]');
		const playVideoButton = this.getRoot()[0].querySelector('[data-component="video-button"]');
		const playVideoOverlay = this.getRoot()[0].querySelector('[data-component="video-overlay"]');

		if (videoContainer) {
			// Resize video
			const wpVideo = videoContainer.querySelector('.wp-video');

			if (wpVideo) {
				wpVideo.style.width = '100%';
				wpVideo.style.height = '100%';
			}

			const wpVideoShortcode = videoContainer.querySelector('.wp-video-shortcode');
			if (wpVideoShortcode) {
				wpVideoShortcode.style.width = '100%';
				wpVideoShortcode.style.height = '100%';
			}

			const video = videoContainer.querySelector('video');
			if (video) {
				video.style.width = '100%';
				video.style.height = '100%';
			}

			const videoPlayerOverlay = videoContainer.querySelector('.mejs-overlay-play');

			// Setup close button
			const reveal = videoContainer.closest('#secondary_demo');
			if (reveal) {
				$('#secondary_demo').on('closed.zf.reveal', () => {
					const videoTag = videoContainer.querySelector('video');

					if (videoTag) {
						if (!videoTag.paused && !videoTag.ended) {
							if (videoPlayerOverlay) {
								videoPlayerOverlay.click(); // Stop the video playback
							}
						}
					}

					if (playVideoOverlay) {
						playVideoOverlay.style.display = '';
					}
				});
			} else {
				console.error('Something went horribly wrong! There is no reveal for the secondary_demo form');
			}

			// Setup play button
			if (playVideoButton) {
				playVideoButton.addEventListener('click', async () => {
					let formData = {
						FirstName: 'Anonymous',
						LastName: 'Anonymous',
						Email: 'anonymous@iterable.com',
						Country: 'United States',
						State: 'Alaska',
						formid: "1134",
						munchkinId: "723-YAV-537"
					};

					const ctaAfterSubmission = new CtaAfterSubmission();
					formData = ctaAfterSubmission.loadFormData();
					formData['formid'] = '1134';
					formData['formVid'] = '1134';

					if ('Country' in formData) {
						if (formData['Country'] === 'United States') {
							if (!formData['State']) {
								formData['State'] = 'Alaska';
							}
						} else if (formData['Country'] === 'Canada') {
							if (!formData['State']) {
								formData['State'] = 'Alberta';
							}
						}
					}

					if (playVideoOverlay) {
						playVideoOverlay.style.display = 'none';
					}

					videoContainer.style.display = '';
					if (videoPlayerOverlay) {
						videoPlayerOverlay.click();
					}

					try {
						if (window.location.hostname !== "localhost" && !this.wasSubmittedDuringThisSession()) {
							await FormController.marketo__submit(formData, undefined, undefined, undefined);
							this.whenSubmitted();
						} else {
							console.log("Marketo submit does not work in localhost, please test it in the staging environment! Skipping submission for now...");
						}
					} catch (e) {
						console.error("Failed to submit MQL attribution to Marketo!");
					}
				});
			} else {
				console.error("Play video button was not found!");
			}
		} else {
			console.error("Video container was not found!");
		}
	}

	/**
	 * @returns {boolean}
	 */
	wasSubmittedDuringThisSession() {
		return !!window.sessionStorage.getItem(this.SUBMITTED_DURING_THIS_SESSION);
	}

	whenSubmitted() {
		window.sessionStorage.setItem(this.SUBMITTED_DURING_THIS_SESSION, "true");
	}
}

module.exports = SecondaryDemoFormStepper;
